import styled from "styled-components";

export const WrapperHeaderThree = styled.nav`
  background-color: #2c2c2d;
  height: 35.75px;
  @media only screen and (max-width: 1200px) {
    width: 1200px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    width: 100%;
    height: auto;
  }
`;

export const HeaderThreeList = styled.ul`
  > li:last-child .headerThreeDropDown,
  > li:nth-child(5) .headerThreeDropDown {
    ${({ theme }) => (theme.isRTL ? `left:0` : `right:0`)};
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    /* CSS styles specific to iPads in landscape mode */
    /* Add your styles here */
    > li:last-child .headerThreeDropDown,
    > li:nth-child(4) .headerThreeDropDown,
    > li:nth-child(6) .headerThreeDropDown {
      ${({ theme }) => (theme.isRTL ? `left:0` : `right:0`)};
    }
    > li:last-child .headerThreeDropDownSub2,
    > li:nth-child(5) .headerThreeDropDownSub2 {
      [dir="rtl"] & {
        left: 100%;
        right: unset;
      }

      [dir="ltr"] & {
        left: unset;
        right: 100%;
      }
    }
  }
`;

export const HeaderThreeMainTabCont = styled.li`
  & .headerThreeDropDown {
    opacity: 0;
    visibility: hidden;
    top: 50px;
    transition: all 0s ease;
    z-index: 2;
  }

  & .headerThreeDropDown:not(.allMenu) {
    width: 232px;
  }

  &:hover .headerThreeDropDown {
    top: 35px;
    visibility: visible;
    transition: all 0.6s ease;
    opacity: 1;
  }

  & > a:after,
  .otherMenu:after {
    content: "";
    position: absolute;
    bottom: 2.5px;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: #fff;
    opacity: 0;
    z-index: 2;
    overflow: hidden;
    transition: opacity 300ms, transform 300ms;
  }

  &:hover > a:after,
  &:hover > .otherMenu:after {
    opacity: 1;
    transform: translate3d(0, 0.2em, 0);
  }

  & .openFirstChild + ul > li:first-child > div {
    opacity: 1;
    visibility: visible;
  }

  & .openFirstChild + ul > li:first-child {
    background-color: var(--gray);
  }

  & .openFirstChild + ul > li:first-child span {
    font-weight: bold;
  }
`;

export const HeaderThreeDropDown = styled.ul`
  box-shadow: 0 4px 15px 4px rgb(0 0 0 / 15%);
  min-height: 380px;
`;

export const HeaderThreeDropDownSub = styled.div`
  top: 0;
  width: 355px;
  @media only screen and (max-width: 1200px) {
    width: 308px;
  }
  min-height: 100%;
  background-color: var(--gray);

  &.lastTwoMenus {
    [dir="rtl"] & {
      left: 100%;
    }

    [dir="ltr"] & {
      right: 100%;
    }
  }

  &:not(.lastTwoMenus) {
    [dir="rtl"] & {
      right: 100%;
    }

    [dir="ltr"] & {
      left: 100%;
    }
  }
  .seeAll{
  {${({ theme: { isRTL } }) => (isRTL ? "text-align:left;" : "text-align:right;")}}
  }
`;

export const HeaderThreeSubTabCont = styled.li`
  & > div {
    opacity: 0;
    visibility: hidden;
  }

  :first-child {
    border-top: 8px solid #fff;
  }

  &:hover .hoverSubCat {
    font-weight: bold;
    background-color: var(--gray);
  }

  :hover > div {
    opacity: 1;
    visibility: visible;
  }
`;

export const SubListBottom2 = styled.div`
  border-top: 1px solid #fff;
`;
